import React from 'react'
import { useParams } from 'react-router-dom'
import { connect } from 'react-redux'
import { useSelector } from "react-redux"
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { styles } from '../layout/styles'
import { useNavigate } from 'react-router-dom';
import { Button, Card, CardBody } from 'react-bootstrap'

const EntityDetails = (props) => {
    const {id} = useParams()
    //onsole.log(id)
    const entity = useSelector(state => state.firestore.data.entities[id])
    //console.log(entity)
    const navigate = useNavigate();
    
    if (entity) {
        return (
            <div style={styles.MainBGDivNoAlign}>
                <div className='container section entity-details'>
                    <div className='card z-depth-0'>
                        <div className='card-content'>
                            <span className='card-title'>Name: {entity.firstname} {entity.lastname}</span>
                            <p>Gender: {entity.gender}</p>
                            <p>Date of birth: {entity.dateofbirth.toDate().toDateString()}</p>
                            <p>Height: {entity.height}</p>
                            <p>Weight: {entity.weight}</p>
                        </div>
                        <div className='card-action gret lighten-4 grey-text'>
                            <div>Start Wellness Program</div>
                            <div>Past Wellnewss Reports</div>
                        </div>        
                        <div style={{ width:'200px', margin:'auto', padding: "20px 20px", }}>
                            <p><Button style={styles.CDFullButton} onClick={() => navigate("/")}>Cancel</Button></p>
                        </div>                    
                    </div>
                </div>
            </div>
          )        
    }
    else {
        <div className='container center'>
            <p>Loading entity...</p>
        </div>
    }
}

// const mapStateToProps = (state, ownProps) => {
//     console.log(ownProps);
//     const entityid = ownProps.match.params.id;
//     console.log(entityid);
//     const entities = state.firestore.data.entities;
//     const entity = entities ? entities[entityid] : null   
//     return {
//         entity: entity
//     }
//   }
  
export default compose(
    firestoreConnect([
      { collection: 'entities' }
    ]),
    //connect(mapStateToProps)
  )(EntityDetails)

